import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBilling = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.1875 4.9375H9.3125M5.1875 7.5625H7.6875M5.1875 10.1875H6.375M7.375 12.8125H3.3125C3.08044 12.8125 2.85788 12.7203 2.69378 12.5562C2.52969 12.3921 2.4375 12.1696 2.4375 11.9375V2.3125C2.4375 2.08044 2.52969 1.85788 2.69378 1.69378C2.85788 1.52969 3.08044 1.4375 3.3125 1.4375H9.51275C9.74465 1.43755 9.96705 1.52966 10.1311 1.69358L11.8064 3.36892C11.9703 3.53295 12.0625 3.75535 12.0625 3.98725V4.9375M10.6607 12.9936C10.8312 13.2179 11.0534 13.3977 11.3083 13.5177C11.5631 13.6378 11.8432 13.6945 12.1247 13.6831C13.0222 13.6831 13.7503 13.137 13.7503 12.4641C13.7503 11.7912 13.0222 11.2452 12.1247 11.2452C11.2273 11.2452 10.5 10.6991 10.5 10.0255C10.5 9.35176 11.2273 8.8065 12.1247 8.8065C12.4062 8.79529 12.6862 8.8521 12.9411 8.97212C13.1959 9.09214 13.4181 9.27183 13.5888 9.49595M12.1245 13.6877V14.5M12.1245 8V8.81158",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBilling;
